import {
  IProductSlotState,
  IPSSExtensions,
} from "@/types/db/product-slot-state";
import {
  getModule,
  VuexModule,
  Mutation,
  Module,
} from "vuex-module-decorators";
import store from "..";
import { IProductCategory } from "@/types/db/product-category";
import { PSSErrors } from "@/constants/errors/product-slot-state";
import { IProductSlotBooking } from "@/types/db/product-slot-booking";
@Module({ dynamic: true, namespaced: true, store, name: "PSS" })
class PSSStoreModule extends VuexModule {
  public pssExtensions: IPSSExtensions = {};
  @Mutation
  addPSSExtensions(
    data: {
      psc: IProductCategory | null;
      pss: IProductSlotState;
      sameStockPCs?: number[];
    }[]
  ) {
    for (const d of data) {
      const { psc, pss } = d;
      const uuid = pss.uuid as string;
      if (!uuid) {
        throw new Error(PSSErrors.HasNoUUID);
      }
      if (psc) {
        const price = psc.prices.find((price) => price.id === pss.priceId);
        const taxes = price && price.taxes ? price.taxes : [];

        this.pssExtensions[uuid] = {
          tickerGroups: psc.ticketGroups,
          taxes: taxes,
          sameStockPCs:
            d.sameStockPCs && d.sameStockPCs.length ? d.sameStockPCs : [],
        };
      } else {
        // In case the pss is actually a donation coming from backend we don't have its psc supplied
        // e.g: Locarno
        this.pssExtensions[uuid] = {
          tickerGroups: [],
          taxes: [],
          sameStockPCs: [],
        };
      }
    }
  }
  @Mutation
  removePSSExtension(uuid: string) {
    if (this.pssExtensions[uuid]) {
      delete this.pssExtensions[uuid];
    }
  }
  @Mutation
  removePSSExtensionsBatch(uuids: string[]) {
    const pssExtensionsCopy = { ...this.pssExtensions };
    uuids.forEach((uuid) => {
      if (pssExtensionsCopy[uuid]) {
        delete pssExtensionsCopy[uuid];
      }
    });
    this.pssExtensions = pssExtensionsCopy;
  }
  @Mutation
  removePSSExtensionsByBooking(booking: IProductSlotBooking) {
    if (booking.pssList && booking.pssList.length) {
      const pssExtensionsCopy = { ...this.pssExtensions };
      booking.pssList.forEach((pss) => {
        delete pssExtensionsCopy[pss.uuid as string];
      });
      this.pssExtensions = pssExtensionsCopy;
    }
  }
  @Mutation
  setPSSExtensions(data: IPSSExtensions) {
    this.pssExtensions = data;
  }
}

const PSSModule = getModule(PSSStoreModule);
export default PSSModule;
